// extracted by mini-css-extract-plugin
module.exports = {"root":"HeroLink_root__32hs1","label":"HeroLink_label__1j40_","label--is-small":"HeroLink_label--is-small__dEpQm"};